import Vue from "vue";
import Router from "vue-router";
// const originalPush = Router.prototype.push;
// Router.prototype.push = function push(location, onResolve, onReject) {
//   if (onResolve || onReject) {
//     return originalPush.call(this, location, onResolve, onReject);
//   }
//   return originalPush.call(this, location).catch((err) => err);
// };

Vue.use(Router);

/* Layout */
import Layout from "@/layout";
import TowLevelView from "@/layout/towLevelView";

/* Router Modules */
import componentsRouter from "./modules/components";
import chartsRouter from "./modules/charts";
import tableRouter from "./modules/table";
import nestedRouter from "./modules/nested";
import $vue from "@/main";

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path(.*)",
        component: () => import("@/views/redirect/index"),
      },
    ],
  },
  {
    path: "/",
    redirect: "/login",
    hidden: true,
  },
  {
    path: "/register",
    hidden: true,
    component: () => import("@/views/register/index"),
  },
  {
    path: "/forgetPassword",
    hidden: true,
    component: () => import("@/views/forgetPassword/index"),
  },
  {
    path: "/resetPassword",
    hidden: true,
    component: () => import("@/views/forgetPassword/resetPassword"),
  },
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  {
    path: "/auth-redirect",
    component: () => import("@/views/login/auth-redirect"),
    hidden: true,
  },
  {
    path: "/404",
    component: () => import("@/views/error-page/404"),
    hidden: true,
  },
  {
    path: "/401",
    component: () => import("@/views/error-page/401"),
    hidden: true,
  },
  {
    path: "/refresh",
    name: "refresh",
    hidden: true,
    component: () => import("@/views/refresh/index"),
  },
  {
    path: "/taskLogAdmin",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "index",
        component: () => import("@/views/platformAdmin/taskLogAdmin"),
        name: "TaskLogAdmin",
        meta: {
          title: "任务日志",
          icon: null,
          affix: true,
        },
      },
    ],
  },
  {
    path: "/createHome",
    component: Layout,
    hidden: false,
    meta: {
      title: "route.dashboard",
      icon: "home",
      type: "create",
      affix: true,
    },
    children: [
      {
        path: "index",
        redirect: "/create/materialDataSheet",
        // component: () => import('@/views/create/component/createComponent'),
        meta: {
          title: "route.dashboard",
          type: "create",
          icon: "icon-default",
          affix: true,
        },
      },
    ],
  },
  {
    path: "/createHome2",
    component: Layout,
    hidden: false,
    meta: {
      title: "route.dashboard",
      icon: "home",
      type: "unit",
      affix: true,
    },
    children: [
      {
        path: "index",
        redirect: "/create/componentUnit",
        // component: () => import('@/views/create/component/createComponent'),
        meta: {
          title: "route.dashboard",
          type: "unit",
          icon: "icon-default",
          affix: true,
        },
      },
    ],
  },
  // svhc分析详情页
  {
    path: "/analyse",
    component: Layout,
    hidden: true,
    meta: {
      title: "common.svhcAnalysis",
      icon: "home",
      type: "unit",
      affix: true,
    },
    children:[
      {
        path: "svhcDetail",
        component: () => import("@/views/analyse/analyseSvhcDetail"),
        name: "analyse",
        meta: {
          title: "common.viewDetailed",
          activeMenu: "/analyse/analyseSvhc",
          affix: true,
        },
      },
      {
        path: "svhcDetailResult",
        component: () => import("@/views/analyse/analyseSvhcDetailResult"),
        name: "analyseResult",
        meta: {
          title: "common.viewDetailed",
          activeMenu: "/analyse/analyseSvhcResult",
          affix: true,
        },
      }
    ]
  },
  {
    path: "/auxiliaryVerificationTools",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "result",
        component: () =>
          import(
            "@/views/analyse/auxiliaryVerificationToolsComponent/auxiliaryVerificationToolsResult"
          ),
        name: "auxiliaryVerificationToolsResult",
        meta: {
          title: "mdsSearchResult.result",
          icon: null,
          activeMenu: "/auxiliaryVerificationTool/toolSeekMaterialDataSheet",
          affix: true,
        },
      },
      {
        path: "checkResult",
        component: () =>
          import(
            "@/views/analyse/auxiliaryVerificationToolsComponent/auxiliaryVerificationToolsCheckResult"
          ),
        name: "AuxiliaryVerificationToolsCheckResult",
        meta: {
          title: "auxiliaryVerificationTool.checkResult",
          activeMenu: "/auxiliaryVerificationTool/toolSeekMaterialDataSheet",
          icon: null,
          affix: true,
        },
      },
      {
        path: "SVHCResult",
        component: () =>
          import(
            "@/views/analyse/auxiliaryVerificationToolsComponent/SVHCResult"
          ),
        name: "SVHCResult",
        meta: {
          title: "auxiliaryVerificationTool.SVHC",
          icon: null,
          activeMenu: "/auxiliaryVerificationTool/toolSeekMaterialDataSheet",
          affix: true,
        },
      },
      {
        path: "customCheckActionTool",
        component: () => import("@/views/analyse/customCheckActionTool/index"),
        name: "customCheckActionTool",
        meta: {
          title: "auxiliaryVerificationTool.customCheck",
          icon: null,
          activeMenu: "/auxiliaryVerificationTool/toolSeekMaterialDataSheet",
          affix: true,
        },
      },
      {
        path: "customResultPage",
        component: () =>
          import("@/views/analyse/customCheckActionTool/customResultPage"),
        name: "customResultPage",
        meta: {
          title: "auxiliaryVerificationTool.Verification",
          icon: null,
          activeMenu: "/auxiliaryVerificationTool/toolSeekMaterialDataSheet",
          affix: true,
        },
      },
      {
        path: "substanceResult",
        component: () => import("@/views/seek/substanceResult"),
        name: "substanceResult",
        meta: {
          title: "mdsSearchResult.result",
          icon: null,
          activeMenu: "/auxiliaryVerificationTool/toolSeekMaterialDataSheet",
          affix: true,
        },
      },
      {
        path: "rresult",
        component: () =>
          import(
            "@/views/analyse/auxiliaryVerificationToolsComponent/auxiliaryVerificationToolsResult"
          ),
        name: "rresult",
        meta: {
          title: "mdsSearchResult.result",
          icon: null,
          activeMenu: "/auxiliaryVerificationTool/toolReceiveMdsPage",
          affix: true,
        },
      },
      {
        path: "rcheckResult",
        component: () =>
          import(
            "@/views/analyse/auxiliaryVerificationToolsComponent/auxiliaryVerificationToolsCheckResult"
          ),
        name: "rcheckResult",
        meta: {
          title: "auxiliaryVerificationTool.checkResult",
          activeMenu: "/auxiliaryVerificationTool/toolReceiveMdsPage",
          icon: null,
          affix: true,
        },
      },
      {
        path: "rSVHCResult",
        component: () =>
          import(
            "@/views/analyse/auxiliaryVerificationToolsComponent/SVHCResult"
          ),
        name: "rSVHCResult",
        meta: {
          title: "auxiliaryVerificationTool.SVHC",
          icon: null,
          activeMenu: "/auxiliaryVerificationTool/toolReceiveMdsPage",
          affix: true,
        },
      },
      {
        path: "rcustomCheckActionTool",
        component: () => import("@/views/analyse/customCheckActionTool/index"),
        name: "rcustomCheckActionTool",
        meta: {
          title: "auxiliaryVerificationTool.customCheck",
          icon: null,
          activeMenu: "/auxiliaryVerificationTool/toolReceiveMdsPage",
          affix: true,
        },
      },
      {
        path: "rcustomResultPage",
        component: () =>
          import("@/views/analyse/customCheckActionTool/customResultPage"),
        name: "rcustomResultPage",
        meta: {
          title: "auxiliaryVerificationTool.Verification",
          icon: null,
          activeMenu: "/auxiliaryVerificationTool/toolReceiveMdsPage",
          affix: true,
        },
      },
      {
        path: "rsubstanceResult",
        component: () => import("@/views/seek/substanceResult"),
        name: "rsubstanceResult",
        meta: {
          title: "mdsSearchResult.result",
          icon: null,
          activeMenu: "/auxiliaryVerificationTool/toolReceiveMdsPage",
          affix: true,
        },
      },
    ],
  },
  {
    path: "/createComponent",
    component: Layout,
    hidden: false,
    meta: {
      title: "mdsupdate.mds",
      icon: "materialDataSheet",
      type: "create",
      affix: true,
    },
    children: [
      {
        path: "detail",
        component: () => import("@/views/create/component/createComponent"),
        name: "createComponent",
        meta: {
          title: "common.detail",
          icon: "icon-default",
          affix: true,
        },
      },
      {
        path: "ourinformationCompany",
        component: () =>
          import("@/views/create/component/ourinformationCompany"),
        name: "OurinformationCompany",
        meta: {
          title: "auxiliaryVerificationTool.Information",
          icon: "icon-default",
          type: "create",
          affix: true,
        },
      },
      {
        path: "sendStatusInformation",
        component: () =>
          import("@/views/create/component/sendStatusInformation"),
        name: "sendStatusInformation",
        meta: {
          title: "auxiliaryVerificationTool.SendSI",
          icon: "icon-default",
          type: "create",
          affix: true,
        },
      },
    ],
  },
  {
    path: "/other/mdsUpdate/results",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "",
        component: () => import("@/views/other/mdsUpdate/results"),
        name: "mdsUpdateResults",
        meta: {
          title: "common.mdsUpdateResults",
          icon: "icon-default",
          affix: true,
          activeMenu: "/other/mdsUpdate",
        },
      },
    ],
  },
  // {
  //   path: '/dataTransform',
  //   component: Layout,
  //   hidden: false,
  //   meta:{
  //     title: 'common.detail',
  //   },
  //   children: [{
  //     path: 'CQCDataDownLoad',
  //     component: () => import('@/views/dataTransform/CQCDataDownLoad'),
  //     hidden: false,
  //     meta: {
  //       keepAlive: true
  //     },
  //   }, ],
  // },
  {
    path: "/createComponentUnit",
    component: Layout,
    hidden: false,
    meta: {
      title: "auxiliaryVerificationTool.model",
      icon: "documentation",
      type: "unit",
      affix: true,
    },
    children: [
      {
        path: "detail",
        component: () => import("@/views/create/component/createComponent"),
        name: "CreateComponentUnit",
        meta: {
          title: "common.detail",
          icon: "icon-default",
          affix: true,
        },
      },
    ],
  },
  {
    path: "/toolReceived",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "toolReceiveMdsPage",
        component: () => import("@/views/seek/toolReceiveMdsPage"),
        name: "RoolReceiveMdsPage",
        meta: {
          title: "receivemds.sendTable",
          icon: "icon-default",
          activeMenu: "/auxiliaryVerificationTool/toolReceiveMdsPage",
          affix: true,
        },
      },
    ],
  },
  {
    path: "/seek",
    component: Layout,
    hidden: true,
    meta: {
      title: "common.find",
      icon: "documentation",
      affix: true,
    },
    children: [
      {
        path: "detail",
        component: () => import("@/views/create/component/createComponent"),
        name: "SeekComponent",
        meta: {
          title: "common.detail",
          icon: "icon-default",
          affix: true,
        },
      },
      {
        path: "receiveMdsPage",
        component: () => import("@/views/seek/receiveMdsPage"),
        name: "ReceiveMdsPage",
        meta: {
          title: "receivemds.sendTable",
          icon: "icon-default",
          activeMenu: "/seek/seekReceived",
          affix: true,
        },
      },
      {
        path: "sendMdsPage",
        component: () => import("@/views/seek/sendMdsPage"),
        name: "SendMdsPage",
        meta: {
          title: "receivemds.sendTable1",
          icon: "icon-default",
          activeMenu: "/seek/seekHasBeenSent",
          affix: true,
        },
      },
    ],
  },
  {
    path: "/setUserManage",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "index",
        component: () => import("@/views/other/setUserManage"),
        name: "setUserManage",
        meta: {
          title: "global.set",
          icon: "guide",
          noCache: true,
        },
      },
    ],
  },
  //components.SCIPNotificationDetail = () => import('@/views/scipDocking/SCIPNotification/SCIPNotificationDetail.vue')
  {
    path: "/scipDocking",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "SCIPNotificationDetail",
        component: () =>
          import(
            "@/views/scipDocking/SCIPNotification/SCIPNotificationDetail.vue"
          ),
        name: "SCIPNotificationDetail",
        meta: {
          title: "SCIPNotificationDetail",
          icon: "icon-default",
        },
      },
    ],
  },
  {
    path: "/platformAdmin",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "entorguserstsatic",
        component: TowLevelView,
        meta: {
          title: "entorguser.title",
          icon: "documentation",
          affix: true,
        },
        children: [
          {
            path: "entorguserinput",
            component: () =>
              import("@/views/platformAdmin/components/entorguserInput"),
            name: "entorguserInput",
            meta: {
              title: "entorguserinput.title",
              icon: "documentation",
              affix: true,
            },
          },
          {
            path: "modifyEntorguserinput",
            component: () =>
              import("@/views/platformAdmin/components/modifyEntorguserInput"),
            name: "modifyEntorguserinput",
            meta: {
              title: "entorguserinput.title2",
              icon: "documentation",
              affix: true,
            },
          },
        ],
      },
      {
        path: "substanceLayout",
        component: TowLevelView,
        meta: {
          title: "substanceSearchAction.substancemanager",
          icon: "documentation",
          affix: true,
        },
        children: [
          {
            path: "substanceInsert",
            component: () =>
              import("@/views/platformAdmin/components/substanceInsert"),
            name: "substanceInsert",
            meta: {
              title: "substanceSearchAction.substanceinsert",
              icon: "documentation",
              affix: true,
            },
          },
        ],
      },
      {
        path: "substanceLayout",
        component: TowLevelView,
        meta: {
          title: "substanceSearchAction.substancemanager",
          icon: "documentation",
          affix: true,
        },
        children: [
          {
            path: "substanceModify",
            component: () =>
              import("@/views/platformAdmin/components/substanceInsert"),
            name: "substanceModify",
            meta: {
              title: "substanceSearchAction.substanceModify",
              icon: "documentation",
              affix: true,
            },
          },
        ],
      },
    ],
    meta: {
      title: "usermessage.statusTitle",
      icon: "documentation",
      affix: true,
    },
  },
  {
    path: "/search",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "receive",
        component: TowLevelView,
        meta: {
          title: "mdsStatistics.subTitle",
          icon: "documentation",
          affix: true,
        },
        children: [
          {
            path: "receiveMds",
            component: () =>
              import(
                "@/views/platformAdmin/components/mdsStatistics/receiveMds"
              ),
            name: "receiveMds",
            meta: {
              title: "mdsStatistics.level2Title",
              icon: "documentation",
              affix: true,
            },
          },
        ],
      },
      {
        path: "send",
        component: TowLevelView,
        meta: {
          title: "mdsStatistics.subTitle1",
          icon: "documentation",
          affix: true,
        },
        children: [
          {
            path: "sendMds",
            component: () =>
              import("@/views/platformAdmin/components/mdsStatistics/sendMds"),
            name: "sendMds",
            meta: {
              title: "mdsStatistics.level2Title1",
              icon: "documentation",
              affix: true,
            },
          },
        ],
      },
    ],
    meta: {
      title: "mdsStatistics.search",
      icon: "documentation",
      affix: true,
    },
  },
  {
    path: "/request",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "mdsDataRequestShowResult",
        component: () => import("@/views/request/mdsDataRequestShowResult"),
        meta: {
          title: "mdsdatarequest.subTitle",
          icon: "documentation",
          affix: true,
        },
      },
      {
        path: "mdsDataRequest",
        component: TowLevelView,
        meta: {
          title: "mdsdatarequest.subTitle",
          icon: "documentation",
          affix: true,
        },
        children: [
          {
            path: "view",
            component: () => import("@/views/request/requestView"),
            name: "requestView",
            meta: {
              title: "mdsdatarequest.watch",
              icon: "documentation",
              affix: true,
            },
          },
          {
            path: "edit",
            component: () => import("@/views/request/editSeltRequest"),
            name: "requestEdit",
            meta: {
              title: "mdsdatarequest.edit",
              icon: "documentation",
              affix: true,
            },
          },
          {
            path: "editReceive",
            component: () => import("@/views/request/editReceiveRequest"),
            name: "requestEditReceive",
            meta: {
              title: "mdsdatarequest.edit",
              icon: "documentation",
              affix: true,
            },
          },
        ],
      },
    ],
    meta: {
      title: "mdsdatarequest.requestTitle",
      icon: "documentation",
      affix: true,
    },
  },
  // {
  //   path: '/profile',
  //   component: Layout,
  //   redirect: '/profile/index',
  //   hidden: true,
  //   children: [{
  //     path: 'index',
  //     component: () => import('@/views/profile/index'),
  //     name: 'Profile',
  //     meta: {
  //       title: 'profile',
  //       icon: 'user',
  //       noCache: true
  //     }
  //   }]
  // }
];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  {
    path: "/permission",
    component: Layout,
    redirect: "/permission/page",
    alwaysShow: true, // will always show the root menu
    name: "Permission",
    meta: {
      title: "permission",
      icon: "lock",
      roles: ["admin", "editor"], // you can set roles in root nav
    },
    children: [
      {
        path: "page",
        component: () => import("@/views/permission/page"),
        name: "PagePermission",
        meta: {
          title: "pagePermission",
          roles: ["admin"], // or you can only set roles in sub nav
        },
      },
      {
        path: "directive",
        component: () => import("@/views/permission/directive"),
        name: "DirectivePermission",
        meta: {
          title: "directivePermission",
          // if do not set roles, means: this page does not require permission
        },
      },
      {
        path: "role",
        component: () => import("@/views/permission/role"),
        name: "RolePermission",
        meta: {
          title: "rolePermission",
          roles: ["admin"],
        },
      },
    ],
  },

  {
    path: "/icon",
    component: Layout,
    children: [
      {
        path: "index",
        component: () => import("@/views/icons/index"),
        name: "Icons",
        meta: {
          title: "icons",
          icon: "icon",
          noCache: true,
        },
      },
    ],
  },

  /** when your routing map is too long, you can split it into small modules **/
  componentsRouter,
  chartsRouter,
  nestedRouter,
  tableRouter,

  {
    path: "/example",
    component: Layout,
    redirect: "/example/list",
    name: "Example",
    meta: {
      title: "example",
      icon: "el-icon-s-help",
    },
    children: [
      {
        path: "create",
        component: () => import("@/views/example/create"),
        name: "CreateArticle",
        meta: {
          title: "createArticle",
          icon: "edit",
        },
      },
      {
        path: "edit/:id(\\d+)",
        component: () => import("@/views/example/edit"),
        name: "EditArticle",
        meta: {
          title: "editArticle",
          noCache: true,
          activeMenu: "/example/list",
        },
        hidden: true,
      },
      {
        path: "list",
        component: () => import("@/views/example/list"),
        name: "ArticleList",
        meta: {
          title: "articleList",
          icon: "list",
        },
      },
    ],
  },

  {
    path: "/tab",
    component: Layout,
    children: [
      {
        path: "index",
        component: () => import("@/views/tab/index"),
        name: "Tab",
        meta: {
          title: "tab",
          icon: "tab",
        },
      },
    ],
  },

  {
    path: "/error",
    component: Layout,
    redirect: "noRedirect",
    name: "ErrorPages",
    meta: {
      title: "errorPages",
      icon: "404",
    },
    children: [
      {
        path: "401",
        component: () => import("@/views/error-page/401"),
        name: "Page401",
        meta: {
          title: "page401",
          noCache: true,
        },
      },
      {
        path: "404",
        component: () => import("@/views/error-page/404"),
        name: "Page404",
        meta: {
          title: "page404",
          noCache: true,
        },
      },
    ],
  },

  {
    path: "/error-log",
    component: Layout,
    children: [
      {
        path: "log",
        component: () => import("@/views/error-log/index"),
        name: "ErrorLog",
        meta: {
          title: "errorLog",
          icon: "bug",
        },
      },
    ],
  },

  {
    path: "/excel",
    component: Layout,
    redirect: "/excel/export-excel",
    name: "Excel",
    meta: {
      title: "excel",
      icon: "excel",
    },
    children: [
      {
        path: "export-excel",
        component: () => import("@/views/excel/export-excel"),
        name: "ExportExcel",
        meta: {
          title: "exportExcel",
        },
      },
      {
        path: "export-selected-excel",
        component: () => import("@/views/excel/select-excel"),
        name: "SelectExcel",
        meta: {
          title: "selectExcel",
        },
      },
      {
        path: "export-merge-header",
        component: () => import("@/views/excel/merge-header"),
        name: "MergeHeader",
        meta: {
          title: "mergeHeader",
        },
      },
      {
        path: "upload-excel",
        component: () => import("@/views/excel/upload-excel"),
        name: "UploadExcel",
        meta: {
          title: "uploadExcel",
        },
      },
    ],
  },

  {
    path: "/zip",
    component: Layout,
    redirect: "/zip/download",
    alwaysShow: true,
    name: "Zip",
    meta: {
      title: "zip",
      icon: "zip",
    },
    children: [
      {
        path: "download",
        component: () => import("@/views/zip/index"),
        name: "ExportZip",
        meta: {
          title: "exportZip",
        },
      },
    ],
  },

  {
    path: "/pdf",
    component: Layout,
    redirect: "/pdf/index",
    children: [
      {
        path: "index",
        component: () => import("@/views/pdf/index"),
        name: "PDF",
        meta: {
          title: "pdf",
          icon: "pdf",
        },
      },
    ],
  },
  {
    path: "/pdf/download",
    component: () => import("@/views/pdf/download"),
    hidden: true,
  },

  {
    path: "/theme",
    component: Layout,
    children: [
      {
        path: "index",
        component: () => import("@/views/theme/index"),
        name: "Theme",
        meta: {
          title: "theme",
          icon: "theme",
        },
      },
    ],
  },

  {
    path: "/clipboard",
    component: Layout,
    children: [
      {
        path: "index",
        component: () => import("@/views/clipboard/index"),
        name: "ClipboardDemo",
        meta: {
          title: "clipboardDemo",
          icon: "clipboard",
        },
      },
    ],
  },

  {
    path: "/i18n",
    component: Layout,
    children: [
      {
        path: "index",
        component: () => import("@/views/i18n-demo/index"),
        name: "I18n",
        meta: {
          title: "i18n",
          icon: "international",
        },
      },
    ],
  },

  {
    path: "external-link",
    component: Layout,
    children: [
      {
        path: "https://github.com/PanJiaChen/vue-element-admin",
        meta: {
          title: "externalLink",
          icon: "link",
        },
      },
    ],
  },

  // 404 page must be placed at the end !!!
  {
    path: "*",
    redirect: "/404",
    hidden: true,
  },
];

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({
      y: 0,
    }),
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
